type Props = {
    width?: number | string;
    height?: number | string;
    className?: string;
    style?: React.CSSProperties;
    id?: string | number;
};

export function DecorationIcon({ width = 24, height = 24, className, style }: Props) {
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width={width}
            height={height}
            viewBox="0 0 24 24"
            fill="none"
            className={className}
            style={style}
        >
            <path
                d="M10.9994 2.17843C11.6185 1.82073 12.3815 1.82073 13.0006 2.17843L19.7507 6.07851L12 10.5567L4.24931 6.07851L10.9994 2.17843Z"
                fill="currentColor"
            />
            <path
                d="M13.25 12.7217L21 8.24397V16.0461C21 16.7604 20.619 17.4204 20.0006 17.7778L13.25 21.6781V12.7217Z"
                fill="currentColor"
            />
            <path
                d="M3 8.24397L10.75 12.7217V21.6781L3.99944 17.7778C3.38095 17.4204 3 16.7604 3 16.0461V8.24397Z"
                fill="currentColor"
            />
        </svg>
    );
}

export default DecorationIcon;
